import sectionEdit from './sectionEdit'

export const sectionEditService = sectionEdit
